export const config = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:8080',
  cognito: {
    region: import.meta.env.VITE_COGNITO_REGION || 'us-east-1',
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
    domain: import.meta.env.VITE_COGNITO_DOMAIN || '',
  },
  appUrl: import.meta.env.VITE_APP_URL || 'http://localhost:3001',
};

export const cognitoOAuthConfig = {
  domain: config.cognito.domain,
  redirectSignIn: `${config.appUrl}/callback`,
  redirectSignOut: config.appUrl,
  responseType: 'code' as const,
  scope: ['openid', 'email', 'profile'],
};
